// for pop-up
$(".view-bund").on('click', function() {
  $(".custom-model-main").addClass('model-open');
}); 
$(".close-btn, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
});

  document.querySelectorAll('.tab-btn').forEach(button => {
    button.addEventListener('click', function() {
     
      document.querySelectorAll('.tab-btn').forEach(btn => btn.classList.remove('active'));
     
      this.classList.add('active');

      document.querySelectorAll('.bundle-tab-content').forEach(content => content.classList.remove('active'));
    
      document.getElementById(this.getAttribute('data-tab')).classList.add('active');
    });
  });
 $(document).ready(function() {


    $('.tab-btn').on('click', function() {
  
    const selectedTab = $(this).data('tab');
    const selectedLength = $(this).data('length');

    $('.bundle-tab-content').removeClass('active');
    $('#' + selectedTab).addClass('active');

    updateProductLength(selectedLength);
  });

  function updateProductLength(length) {
    
    $('.item-prod').text(length + ' products.');
  }
   
 $('.watch-atc').on('click', function() {
        const productItem = $(this).closest('.product-item');
        const productTitle = productItem.find('h3').text();
        const productPrice = productItem.find('p').text();
        const productImage = productItem.find('img').attr('src');
        const variantId = $(this).data('variant-id');
      
        const selectedLength = $('.tab-btn.active').data('length');
        
        
        let currentItemCount = $('.cart-item').length;

        if (currentItemCount < selectedLength) {
         
            const cartItem = `
<div class="main-carts">
                <div class="cart-item" data-title="${productTitle}" data-price="${productPrice}" data-variant-id="${variantId}">
<div class="cus-l">                   
 <img src="${productImage}" alt="${productTitle}">
 </div>
                    <div class="cus-r"><h4 class="truncate">${productTitle}</h4>
                    <p>${productPrice}</p>
                    <button class="remove-item" data-variant-id="${variantId}">Remove</button>
                    </div>
                </div>
                </div>
            `;

            
            $('.append-prod').append(cartItem);
         
            let itemCount = $('.cart-item').length;
            $('.items').text(`${itemCount} items`);
  updateAddToCartButton();
            updateTotalPrice();
        } else {
           
            alert(`You can only add up to ${selectedLength} products for this selection.`);
        }
    });


function updateTotalPrice() {
    let total = 0;
    let currencySymbol = ''; 

    $('.append-prod .cart-item').each(function() {
        const priceText = $(this).data('price');
        console.log("Raw priceText:", priceText);

        let numericValue;

        if (priceText.includes("€")) {
            numericValue = parseFloat(priceText.replace(/(€|\.)/g, '').replace(',', '.'));
            currencySymbol = '€';
        } else if (priceText.includes("Rs")) {
            numericValue = parseFloat(priceText.replace(/(Rs\.?\s?|,)/g, ''));
            currencySymbol = 'Rs.'; // Indian Rupee symbol
        } else if (priceText.includes("$") && !priceText.includes("C$") && !priceText.includes("S$")) {
            numericValue = parseFloat(priceText.replace(/(\$|,)/g, ''));
            currencySymbol = '$'; // US Dollar
        } else if (priceText.includes("AED") || priceText.includes("د.إ")) {
            numericValue = parseFloat(priceText.replace(/(AED|د\.إ|\s|,)/g, ''));
            currencySymbol = 'د.إ'; // Dirham symbol
        } else if (priceText.includes("R$")) {
            numericValue = parseFloat(priceText.replace(/(R\$|\s|\.|,)/g, '').replace(',', '.'));
            currencySymbol = 'R$'; // Brazilian Real symbol
        } else if (priceText.includes("C$")) {
            numericValue = parseFloat(priceText.replace(/(C\$|,)/g, ''));
            currencySymbol = 'C$'; // Canadian Dollar symbol
        } else if (priceText.includes("CHF")) {
            numericValue = parseFloat(priceText.replace(/(CHF|,|\s)/g, ''));
            currencySymbol = 'CHF'; // Swiss Franc symbol
        } else if (priceText.includes("¥") || priceText.includes("CNY")) {
            numericValue = parseFloat(priceText.replace(/(¥|CNY|\s|,)/g, ''));
            currencySymbol = '¥'; // Chinese Yuan symbol
        } else if (priceText.includes("IDR")) {
            numericValue = parseFloat(priceText.replace(/(IDR|\s|,)/g, ''));
            currencySymbol = 'IDR'; // Indonesian Rupiah symbol
        } else if (priceText.includes("₪") || priceText.includes("ILS")) {
            numericValue = parseFloat(priceText.replace(/(₪|ILS|\s|,)/g, ''));
            currencySymbol = '₪'; // Israeli Shekel symbol
        } else if (priceText.includes("JPY") || priceText.includes("¥")) {
            numericValue = parseFloat(priceText.replace(/(JPY|¥|\s|,)/g, ''));
            currencySymbol = '¥'; // Japanese Yen symbol
        } else if (priceText.includes("₩") || priceText.includes("KRW")) {
            numericValue = parseFloat(priceText.replace(/(₩|KRW|\s|,)/g, ''));
            currencySymbol = '₩'; // South Korean Won symbol
        } else if (priceText.includes("NOK")) {
            numericValue = parseFloat(priceText.replace(/(NOK|\s|,)/g, ''));
            currencySymbol = 'NOK'; // Norwegian Krone symbol
        } else if (priceText.includes("NZD")) {
            numericValue = parseFloat(priceText.replace(/(NZD|\s|,)/g, ''));
            currencySymbol = 'NZD'; // New Zealand Dollar symbol
        } else if (priceText.includes("₱") || priceText.includes("PHP")) {
            numericValue = parseFloat(priceText.replace(/(₱|PHP|\s|,)/g, ''));
            currencySymbol = '₱'; // Philippine Peso symbol
        } else if (priceText.includes("QR") || priceText.includes("QAR")) {
            numericValue = parseFloat(priceText.replace(/(QR|QAR|\s|,)/g, ''));
            currencySymbol = 'QR'; // Qatari Riyal symbol
        } else if (priceText.includes("SAR") || priceText.includes("﷼")) {
            numericValue = parseFloat(priceText.replace(/(SAR|﷼|\s|,)/g, ''));
            currencySymbol = 'SAR'; // Saudi Riyal symbol
        } else if (priceText.includes("SEK")) {
            numericValue = parseFloat(priceText.replace(/(SEK|\s|,)/g, ''));
            currencySymbol = 'SEK'; // Swedish Krona symbol
        } else if (priceText.includes("S$") || priceText.includes("SGD")) {
            numericValue = parseFloat(priceText.replace(/(S\$|SGD|\s|,)/g, ''));
            currencySymbol = 'S$'; // Singapore Dollar symbol
        } else if (priceText.includes("฿") || priceText.includes("THB")) {
            numericValue = parseFloat(priceText.replace(/(฿|THB|\s|,)/g, ''));
            currencySymbol = '฿'; // Thai Baht symbol
        } else if (priceText.includes("₺") || priceText.includes("TRY")) {
            numericValue = parseFloat(priceText.replace(/(₺|TRY|\s|,)/g, ''));
            currencySymbol = '₺'; // Turkish Lira symbol
        } else if (priceText.includes("ZAR") || priceText.includes("R")) {
            numericValue = parseFloat(priceText.replace(/(ZAR|R|\s|,)/g, ''));
            currencySymbol = 'R'; // South African Rand symbol
        } else {
            numericValue = parseFloat(priceText.replace(/[,]/g, ''));
        }

        if (isNaN(numericValue)) {
            console.warn("Invalid price found for calculation:", priceText);
        } else {
            total += numericValue;
        }
    });

    // Format total with two decimal places and appropriate currency symbol
    const formattedTotal = `${currencySymbol} ${total.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    console.log("Formatted Total:", formattedTotal);

    // Count items in the cart
    const itemCount = $('.cart-item').length;

    if (itemCount >= 3) {
        // Apply 15% discount
        const discountTotal = total * 0.85;
        const formattedDiscountTotal = `${currencySymbol} ${discountTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

        // Display crossed-out original price and discounted price
        $('.price-cs').html(`
            <span style="text-decoration: line-through; color: #323232; font-weight:400;">${formattedTotal}</span> 
            <span style="color: #323232;">${formattedDiscountTotal}</span>
        `);
    } else {
        // Display the regular total price
        $('.price-cs').html(`<span>${formattedTotal}</span>`);
    }
}


// function updateTotalPrice() {
//     let total = 0;
//     let currencySymbol = ''; 

//     $('.append-prod .cart-item').each(function() {
//         const priceText = $(this).data('price');
//         console.log("Raw priceText:", priceText);

//         let numericValue;

//         if (priceText.includes("€")) {
         
//             numericValue = parseFloat(priceText.replace(/(€|\.)/g, '').replace(',', '.'));
//             currencySymbol = '€';
//         } else if (priceText.includes("Rs")) {
//             // Handle Rupee format (dot as decimal separator)
//             numericValue = parseFloat(priceText.replace(/(Rs\.?\s?|,)/g, ''));
//             currencySymbol = 'Rs.';
//         } else {
//             // Default case for other formats if needed
//             numericValue = parseFloat(priceText.replace(/[,]/g, ''));
//         }

//         if (isNaN(numericValue)) {
//             console.warn("Invalid price found for calculation:", priceText);
//         } else {
//             total += numericValue;
//         }
//     });

  
//     const formattedTotal = `${currencySymbol} ${total.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//     console.log("Formatted Total:", formattedTotal);

   
//     const itemCount = $('.cart-item').length;

//     if (itemCount >= 3) {
       
//         const discountTotal = total * 0.85;
//         const formattedDiscountTotal = `${currencySymbol} ${discountTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

//         $('.price-cs').html(`
//             <span style="text-decoration: line-through; color: #323232; font-weight:400;">${formattedTotal}</span> 
//             <span style="color: #323232;"> ${formattedDiscountTotal}</span>
//         `);
//     } else {
    
//         $('.price-cs').html(`<span>${formattedTotal}</span>`);
//     }
// }
$('.btn-cart').on('click', function(e) {
  e.preventDefault();

  let productsToAdd = [];
 
  $('.append-prod .cart-item').each(function() {
    const productId = $(this).data('variant-id'); 
console.log(productId);
    if (productId) {
      productsToAdd.push({
        id: productId,
        quantity: 1
      });
    }
  });

  if (productsToAdd.length > 0) {
   
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { items: productsToAdd },
      dataType: 'json',
      success: function() {
        window.location.href = '/cart';
      },
      error: function(xhr) {
        alert('There was an error adding the products to the cart.');
      }
    });
  } else {
    
    alert('No items to add to cart.');
  }
});
// function updateAddToCartButton() {
//     const selectedLength = $('.tab-btn.active').data('length');
//     const currentItemCount = $('.cart-item').length;

//     if (currentItemCount >= selectedLength) {
//         $('.btn-cart').prop('disabled', false).addClass('active-class'); 
//     } else {
//         $('.btn-cart').prop('disabled', true).removeClass('active-class'); 
//     }
// }
function updateAddToCartButton() {
    const selectedLength = $('.tab-btn.active').data('length');
    const currentItemCount = $('.cart-item').length;
    const discountTextElement = $('.price-cs .off-text');

    if (currentItemCount >= selectedLength) {
        $('.btn-cart').prop('disabled', false).addClass('active-class'); 

        
        if (currentItemCount >= 5) {
              $('.off-text').text('(20% off)');
        } else if (currentItemCount >= 3) {
              $('.off-text').text('(15% off)');
           $('.custom-bundle').prop('disabled', false).addClass('main-class'); 
        } else {
            discountTextElement.text(''); 
        }
    } else {
        $('.btn-cart').prop('disabled', true).removeClass('active-class');
       $('.custom-bundle').prop('disabled', true).removeClass('main-class'); 
        discountTextElement.text(''); 
    }
}


$(document).on('click', '.watch-atc', function() {
  
    updateAddToCartButton(); 
});

$(document).on('click', '.remove-item', function() {
    const variantId = $(this).data('variant-id');
    $(this).closest('.cart-item').remove();

    updateTotalPrice();

    let itemCount = $('.cart-item').length;
    $('.items').text(`${itemCount} items`);

    updateAddToCartButton();
});


});


$(document).ready(function(){
    $('.custom-bundle').on('click', function(){
        $(this).toggleClass('bundle-class');
    });
     $('.order-text').on('click', function(){
        $(this).toggleClass('rem-class');
    });
});


